import { render } from "./MyTvl.vue?vue&type=template&id=3ca61a4d&scoped=true"
import script from "./MyTvl.vue?vue&type=script&lang=ts"
export * from "./MyTvl.vue?vue&type=script&lang=ts"

import "./MyTvl.vue?vue&type=style&index=0&id=3ca61a4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ca61a4d"

export default script